export default "__VITE_ASSET__Nhp_yl3l__"